import React from 'react'
import LockPersonOutlinedIcon from '@mui/icons-material/LockPersonOutlined'
import moment from 'moment'
import history from 'utils/history'

import { useDispatch } from 'react-redux'
import { successLogin } from 'redux/auth/actions'

import styles from './styles'
import AnimatedCheckmark from "../../../components/Animated/Checkmark"
import CountdownTimer from "../../../components/CountdownTimer"

const PasswordSuccess = () => {
  const classes = styles()
  const dispatch = useDispatch()

  const handleTimeout = () => {
    dispatch(successLogin(''))
    history.push('/login')
    history.go(0)
  }

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <div className={classes.titleBar}>
          <div className={classes.locker}>
            <LockPersonOutlinedIcon fontSize="inherit" />
          </div>
          <h1 className={classes.title}>Nova Senha criada com sucesso</h1>
          <h3 className={classes.subtitle}>
            Você será redirecionado em instantes para a tela de login.
          </h3>
        </div>
        <AnimatedCheckmark />
      </div>
      <div className={classes.hiddenCounter}>
        <CountdownTimer time={moment().add(5, 's')} callback={handleTimeout} />
      </div>
    </div>
  )
}

export default PasswordSuccess
